import { ReduxStore } from 'store/types';

function editIsLoading(state: ReduxStore): boolean {
  return state.category.edit.config.isLoading;
}

export default editIsLoading;
